<template>
	<Spin size="large" fix v-show="true"></Spin>
</template>
<script>
export default {
	async created() {
		this.getCurrentStep()
	},
	methods: {
		async getCurrentStep() {
			try {
				let response = await this.$http.get('api/FreshmanStep/Me/Current')
				let step = response.data
				this.$router.push('/plans/' + step.RecruitPlanId + '/steps/' + step.Id)
			} catch (error) {
				this.$Message.error(this.$t('非本階段報到'))
				this.$router.push('/login')
			}
		},
	},
}
</script>
